"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledImage = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledImage = styled_components_1.default.img `
  margin: 0 8px 0 5px;
  width: 20px;
`;
